import { render, staticRenderFns } from "./ProcessSentenceTokens.vue?vue&type=template&id=154cebcd&"
import script from "./ProcessSentenceTokens.vue?vue&type=script&lang=js&"
export * from "./ProcessSentenceTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports